import { render, staticRenderFns } from "./StemdoerCard.vue?vue&type=template&id=4c3ac1e1&scoped=true"
import script from "./stemdoerCard.ts?vue&type=script&lang=ts&external"
export * from "./stemdoerCard.ts?vue&type=script&lang=ts&external"
import style0 from "./StemdoerCard.vue?vue&type=style&index=0&id=4c3ac1e1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3ac1e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3ac1e1')) {
      api.createRecord('4c3ac1e1', component.options)
    } else {
      api.reload('4c3ac1e1', component.options)
    }
    module.hot.accept("./StemdoerCard.vue?vue&type=template&id=4c3ac1e1&scoped=true", function () {
      api.rerender('4c3ac1e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/explore/stemdoer-list/stemdoer-card/StemdoerCard.vue"
export default component.exports